import { LocalStorage } from 'quasar'

export function LAYOUT_SET_SIDE_MENU_SHADOW (state, status) {
  state['sideMenuShadow'] = status
}

export function LAYOUT_SET_ROUTER_POPUP (state, status) {
  state['routerPopup'] = status
}

export function LAYOUT_SET_TABLES_POPUP (state, status) {
  state['tablesPopup'] = status
}

export function LAYOUT_SET_DEFERRED (state, status) {
  LocalStorage.set('layout.deferred', status)
  state.deferred = status
}

export function LAYOUT_SET_PAYMENTS_POPUP (state, status) {
  state['paymentsPopup'] = status
}

export function LAYOUT_SET_LOGIN_POPUP (state, status) {
  state['loginPopup'] = status
}

export function LAYOUT_SET_BUSINESS_POPUP (state, status) {
  state['businessPopup'] = status
}

export function LAYOUT_SET_FONT_ZOOM (state, payload) {
  state.fontZoom = payload
  LocalStorage.set('layout.zoom', payload)
}
